module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kFnKq"))).then(() => parcelRequire('9Lwss'));